import { css } from 'styled-components';

export const heading1 = css`
  font-size: 1.75rem;
  font-weight: 700;
  line-height: 1.2;
`;

export const heading2 = css`
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1.2;
`;

export const heading3 = css`
  font-size: 1.25rem;
  font-weight: 700;
  line-height: 1.2;
`;

export const heading4 = css`
  font-size: 0.875rem;
  font-weight: 700;
  line-height: 1.28;
`;

export const text = css`
  font-size: 1rem;
  line-height: 1.625;
`;
